<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { cookieSet } from '@/common/cookie'
import { messages } from '@/i18n'
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  created () {
    this.i18nHandle(this.$i18n.locale)
  },
  methods: {
    i18nHandle (val, oldVal) {
      cookieSet('language', val)
      document.querySelector('html').setAttribute('lang', val)
      document.title = messages[val].brand.lg
      // 非登录页面，切换语言刷新页面
      if (this.$route.name !== 'login' && oldVal) {
        window.location.reload()
      }
    },
    reload() {
			this.isReloadAlive = false
			this.$nextTick(function(){
				this.isReloadAlive = true
			})
		}
  }
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
</style>
